var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BAvatar',{staticClass:"font-weight-500",attrs:{"variant":"primary","src":(_vm.src && _vm.src.length > 0) ? _vm.src : null,"text":_vm.name ? _vm.name.split(' ').map(w => w[0]).join('') : '😎'}})
}
var staticRenderFns = []

export { render, staticRenderFns }